import clsx from 'clsx';
import { type ConfigType } from 'dayjs';

import { Timer } from '@/shared/ui/timer';

import { type ButtonTimerProps } from '../../types';

import s from './ButtonTimer.module.scss';

export const ButtonTimer = <T extends ConfigType = ConfigType>({
  className,
  value,
  onEnd,
}: ButtonTimerProps<T>) => {
  return (
    <Timer timestamp={value} onEnd={onEnd} className={clsx(s.container, className)} />
  );
};
